import { createSlice } from "@reduxjs/toolkit";
import { AppliedappraisalState } from "./appliedappraisalTypes";
import { fetchappliedappraisalById , createappliedappraisal  } from "./appliedappraisalAction";




const initialState: AppliedappraisalState = {
  appliedappraisal: [],
  selectedappliedappraisal: undefined,
  loadingStates: {
    create: false,
    update: false,
    delete: false,
    fetchById: false,
    fetchAll: false,
  },
  errors: {
    create: undefined,
    update: undefined,
    delete: undefined,
    fetchById: undefined,
    fetchAll: undefined,
  },
};

const appliedappraisalSlice = createSlice({
  name: "appraisal",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchappliedappraisalById.pending, (state) => {
        state.loadingStates.fetchById = true;
        state.errors.fetchById = undefined;
      })
      .addCase(fetchappliedappraisalById.fulfilled, (state, action) => {
        state.loadingStates.fetchById = false;
        state.selectedappliedappraisal = action.payload;
      })
      .addCase(fetchappliedappraisalById.rejected, (state, action) => {
        state.loadingStates.fetchById = false;
        state.errors.fetchById = action.payload as string;
      })
      
    .addCase(createappliedappraisal.pending, (state) => {
                                       state.loadingStates.create = true;
                                       state.errors.create = undefined;
                                 })
                                   .addCase(createappliedappraisal.fulfilled, (state, action) => {
                                       state.loadingStates.create = false;
                                       state.appliedappraisal.push(action.payload);
                                   })
                                   .addCase(createappliedappraisal.rejected, (state, action) => {
                                       state.loadingStates.create = false;
                                       state.errors.create = action.payload as string;
                                   })
  },
});

export default appliedappraisalSlice.reducer;
